export default {
  'leaderboardActivity.saving': 'Đang lưu...',
  'leaderboardActivity.operationSuccess': 'Thao tác thành công',
  'leaderboardActivity.search': 'Tìm kiếm',
  'leaderboardActivity.reset': 'Đặt lại',
  'leaderboardActivity.totalRecords': 'Tổng cộng {{total}} bản ghi',

  'leaderboardActivity.listTitle': 'Danh sách hoạt động bảng xếp hạng',
  'leaderboardActivity.addActivity': 'Thêm hoạt động',
  'leaderboardActivity.colName': 'Tên hoạt động',
  'leaderboardActivity.colShowTime': 'Thời gian hiển thị',
  'leaderboardActivity.colEnableTime': 'Thời gian hiệu lực',
  'leaderboardActivity.colSettle': 'Kết toán',
  'leaderboardActivity.colStatus': 'Trạng thái',
  'leaderboardActivity.colCreateTime': 'Thời gian tạo',
  'leaderboardActivity.colUpdateTime': 'Thời gian thao tác',
  'leaderboardActivity.colOperator': 'Người thao tác',
  'leaderboardActivity.colOperation': 'Thao tác',
  'leaderboardActivity.edit': 'Sửa',
  'leaderboardActivity.copy': 'Sao chép',
  'leaderboardActivity.enable': 'Bật',
  'leaderboardActivity.disable': 'Tắt',
  'leaderboardActivity.confirmDisable': 'Tắt hoạt động này?',
  'leaderboardActivity.confirmEnable': 'Bật hoạt động này?',
  'leaderboardActivity.statusNotStarted': 'Chờ hiệu lực',
  'leaderboardActivity.statusRunning': 'Đang diễn ra',
  'leaderboardActivity.statusEnded': 'Đã kết thúc',
  'leaderboardActivity.statusDisabled': 'Đã tắt',
  'leaderboardActivity.settleDaily': 'Hàng ngày',
  'leaderboardActivity.settleEveryNDays': 'Mỗi {{n}} ngày',

  'leaderboardActivity.addTitle': 'Thêm hoạt động bảng xếp hạng',
  'leaderboardActivity.editTitle': 'Sửa hoạt động bảng xếp hạng',
  'leaderboardActivity.save': 'Lưu',
  'leaderboardActivity.back': 'Quay lại',
  'leaderboardActivity.basicSettings': 'Thông tin hoạt động',
  'leaderboardActivity.nameZh': 'Tên hoạt động (Trung)',
  'leaderboardActivity.enterNameZh': 'Nhập tên hoạt động (Trung)',
  'leaderboardActivity.nameEn': 'Tên hoạt động (Anh)',
  'leaderboardActivity.enterNameEn': 'Nhập tên hoạt động (Anh)',
  'leaderboardActivity.currency': 'Loại tiền',
  'leaderboardActivity.selectCurrency': 'Chọn loại tiền',
  'leaderboardActivity.showTime': 'Thời gian hiển thị',
  'leaderboardActivity.selectShowTime': 'Chọn thời gian hiển thị',
  'leaderboardActivity.enableTime': 'Thời gian hiệu lực',
  'leaderboardActivity.selectEnableTime': 'Chọn thời gian hiệu lực',

  'leaderboardActivity.boardRecordsTitle': 'Kết quả chốt bảng',
  'leaderboardActivity.all': 'Tất cả',
  'leaderboardActivity.export': 'Xuất',
  'leaderboardActivity.operationFail': 'Thao tác thất bại',
  'leaderboardActivity.colActivity': 'Hoạt động',
  'leaderboardActivity.colBoard': 'Bảng',
  'leaderboardActivity.colBoardName': 'Tên bảng',
  'leaderboardActivity.colPeriod': 'Chu kỳ',
  'leaderboardActivity.colRank': 'Hạng',
  'leaderboardActivity.colUserAccount': 'Tài khoản hội viên',
  'leaderboardActivity.colMetricValue': 'Giá trị chỉ số',
  'leaderboardActivity.colSnapshotTime': 'Thời gian chụp',
  'leaderboardActivity.filterActivityDate': 'Ngày hoạt động',
  'leaderboardActivity.colVip': 'Cấp VIP',
  'leaderboardActivity.selectVip': 'Chọn cấp VIP',
  'leaderboardActivity.colCoin': 'Loại tiền',
  'leaderboardActivity.colSettleDate': 'Ngày chốt bảng',
  'leaderboardActivity.colYesterdayBet': 'Cược hợp lệ hôm qua',
  'leaderboardActivity.colTodayBet': 'Cược hợp lệ hôm nay',
  'leaderboardActivity.colActivityTotalBet': 'Tổng cược hợp lệ trong hoạt động',
  'leaderboardActivity.summaryTitle': 'Tổng cược hợp lệ',
  'leaderboardActivity.summaryNote':
    'Tất cả hoạt động đang mở　Mỗi hội viên chỉ tính một lần　Không tính hội viên chưa lên bảng　Không thay đổi theo bộ lọc và phân trang',
  'leaderboardActivity.summaryMemberCount': '{{count}} hội viên lên bảng (đã lọc trùng)',
  'leaderboardActivity.summaryLoading': 'Đang thống kê, vui lòng đợi',
  'leaderboardActivity.summaryLoadFail': 'Tải dữ liệu thất bại, vui lòng thử lại',
  'leaderboardActivity.summaryEmpty': 'Chưa có dữ liệu. Các hoạt động đang mở chưa phát sinh bản ghi lên bảng.',
  'leaderboardActivity.summaryRetry': 'Thử lại',
  'leaderboardActivity.colBetCount': 'Số lượt cược',
  'leaderboardActivity.colProfitRate': 'Tỷ lệ lãi',
  'leaderboardActivity.colLastBetTime': 'Thời gian cược gần nhất',
  'leaderboardActivity.colRewardDue': 'Thưởng phải phát',
  'leaderboardActivity.colAwardStatus': 'Trạng thái phát thưởng',
  'leaderboardActivity.rewardTypeCash': 'Tiền mặt',
  'leaderboardActivity.rewardTypePoint': 'Điểm',
  'leaderboardActivity.rewardTypeSpin': 'Vé vòng quay',
  'leaderboardActivity.awardPendingConfirm': 'Chờ xác nhận',
  'leaderboardActivity.awardPendingGrant': 'Chờ phát',
  'leaderboardActivity.awardGranted': 'Đã phát',
  'leaderboardActivity.awardRejected': 'Đã từ chối',
  'leaderboardActivity.actionConfirm': 'Xác nhận phát',
  'leaderboardActivity.actionReject': 'Từ chối',
  'leaderboardActivity.batchConfirm': 'Xác nhận phát hàng loạt',
  'leaderboardActivity.confirmGrantTip': 'Xác nhận phát cho các bản ghi đã chọn? Sẽ chuyển sang Chờ phát và phát bởi batch 16:00.',
  'leaderboardActivity.rejectTip': 'Từ chối các bản ghi đã chọn? Sẽ không phát thưởng.',
  'leaderboardActivity.noSelection': 'Vui lòng chọn bản ghi trước',
  'leaderboardActivity.grantSuccess': 'Thành công, {{n}} bản ghi',

  'leaderboardActivity.awardRecordsTitle': 'Bản ghi phát thưởng',
  'leaderboardActivity.colRewardType': 'Loại thưởng',
  'leaderboardActivity.colRewardValue': 'Giá trị thưởng',
  'leaderboardActivity.colGrantStatus': 'Trạng thái phát',
  'leaderboardActivity.colGrantTime': 'Thời gian phát',
  'leaderboardActivity.grantPending': 'Chờ phát',
  'leaderboardActivity.grantGranted': 'Đã phát',
  'leaderboardActivity.grantFailed': 'Phát thất bại',
  'leaderboardActivity.colRejectReason': 'Lý do từ chối',
};
